/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type GetUserHardwareRequestsQueryVariables = Types.Exact<{
  where: Types.HardwareRequestWhereInput;
}>;

export type GetUserHardwareRequestsQuery = {
  hardwareRequests: Array<
    Pick<
      Types.HardwareRequest,
      | "id"
      | "status"
      | "user_id"
      | "event_id"
      | "created_at"
      | "updated_at"
      | "requested_at"
      | "accepted_at"
      | "ready_at"
      | "picked_up_at"
      | "returned_at"
      | "denied_at"
      | "cancelled_at"
    > & {
      user: Pick<Types.User, "name" | "email">;
      hardware_item_requests: Array<
        Pick<
          Types.HardwareItemRequest,
          "id" | "quantity" | "hardware_item_id"
        > & {
          HardwareItem: Pick<
            Types.HardwareItem,
            "id" | "sku_code" | "total_quantity" | "available_quantity"
          >;
        }
      >;
    }
  >;
};

export const GetUserHardwareRequestsDocument = gql`
  query GetUserHardwareRequests($where: HardwareRequestWhereInput!) {
    hardwareRequests(where: $where) {
      id
      status
      user_id
      event_id
      created_at
      updated_at
      requested_at
      accepted_at
      ready_at
      picked_up_at
      returned_at
      denied_at
      cancelled_at
      user {
        name
        email
      }
      hardware_item_requests {
        id
        quantity
        hardware_item_id
        HardwareItem {
          id
          sku_code
          total_quantity
          available_quantity
        }
      }
    }
  }
`;

/**
 * __useGetUserHardwareRequestsQuery__
 *
 * To run a query within a React component, call `useGetUserHardwareRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserHardwareRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserHardwareRequestsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetUserHardwareRequestsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetUserHardwareRequestsQuery,
    GetUserHardwareRequestsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetUserHardwareRequestsQuery,
    GetUserHardwareRequestsQueryVariables
  >(GetUserHardwareRequestsDocument, baseOptions);
}
export function useGetUserHardwareRequestsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetUserHardwareRequestsQuery,
    GetUserHardwareRequestsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetUserHardwareRequestsQuery,
    GetUserHardwareRequestsQueryVariables
  >(GetUserHardwareRequestsDocument, baseOptions);
}
export type GetUserHardwareRequestsQueryHookResult = ReturnType<
  typeof useGetUserHardwareRequestsQuery
>;
export type GetUserHardwareRequestsLazyQueryHookResult = ReturnType<
  typeof useGetUserHardwareRequestsLazyQuery
>;
export type GetUserHardwareRequestsQueryResult = ApolloReactCommon.QueryResult<
  GetUserHardwareRequestsQuery,
  GetUserHardwareRequestsQueryVariables
>;
